import { GeneralService } from './src/services/generales.services';

export type { Pais } from './src/services/suite.interfaces';

export const generalService = new GeneralService();

export default generalService;
